import { wordCapitalize, APP_LOCAL_DATE_TIME_FORMAT_TYPE2, APP_LOCAL_DATE_FORMAT_TYPE2, APP_LOCAL_TIME_FORMAT, APP_MESSAGE_LIST_DAY_MONTH } from 'config/constants';
import _ from 'lodash';
import moment from 'moment';
import { getRandomColor } from 'utils/getRandomColor';
/**
 * Mapping Inbox Messages 
 * @param data 
 * @author shaheel navas
 * @return JSON
 */
export const InboxMessageMapper = (data, currentDateTime, index) => {
    let authorName = wordCapitalize(data?.authorName?.split(":")[0] ?? null),
        avatarColor = data.color ?? getRandomColor(),
       // recipients = data?.recipients ? convertRecipientArray(data?.recipients) : [],
        recipientType = parseInt(data?.authorName.split(":")[1]),
        lastmsgdatetime = data.modificationDate ?
            moment(data.modificationDate).locale('en').format(APP_LOCAL_DATE_TIME_FORMAT_TYPE2) : null,
        lastmsgdate = data.sentDate ?
            moment(data.sentDate).locale('en').format(APP_LOCAL_DATE_FORMAT_TYPE2) : null,
        lastmsgtime = data.sentDate ?
            moment(data.sentDate).locale('en').format(APP_LOCAL_TIME_FORMAT) : null,
        dateTimeLog = dateTimediff(currentDateTime, data.sentDate);

    return {
        id: data.id,
        //key: index,
        summary: data.title ?? null,
        lastmsgdatetime: lastmsgdatetime,
        lastmsgdate: lastmsgdate,
        lastmsgtime: lastmsgtime,
        author: authorName,
        authorId: data.authorId,
        avatar: null,
        content: data.content,
        color: avatarColor,
        portalMessageThreadId: data.portalMessagethreadId,
        msgRead: data?.msgRead == 1 ? true : false,/** Bug #1009 Date :30/09/2022 Midhila Velayudhan */
        msgStarred: data?.msgStarred == 1 ? true : false,/** Bug #1009 - @Author: Anupama P @Date 30Sep2022 */
        recipientType: recipientType,
        relatedMessageId: data?.relatedMessageId,
        group: data?.patientGroupMasterId !=0 ? true : false,
        patientGroupMasterId: data?.patientGroupMasterId,
        thread: [{
            summary: data.title ?? '',
            messageId: data.id,
            portalMessageThreadId: data.portalMessagethreadId,
            author: authorName,
            authorId: data.authorId,
            avatar: null,
            content: data.content,
            color: avatarColor,
            datetime: data.sentDate ?
                moment(data.sentDate).locale('en').format(APP_LOCAL_DATE_TIME_FORMAT_TYPE2) : null,
            date: data.sentDate ?
                moment(data.sentDate).locale('en').format(APP_LOCAL_DATE_FORMAT_TYPE2) : null,
            time: data.sentDate ?
                moment(data.sentDate).locale('en').format(APP_LOCAL_TIME_FORMAT) : null,
            forms: data.portalAccountForm ? convertFormArray(data.portalAccountForm) : null,
            document: data?.documentName ? convertDocumentArray(data?.documentName) : null,
            fromLabel: authorName,
            toLabel: ["me"],
            replyTo: [{ id: data.authorId, name: authorName }],
            msgRead: data?.msgRead == 1 ? true : false,
            recipientType: recipientType,
            group: data?.patientGroupMasterId !=0 ? true : false,
            patientGroupMasterId: data?.patientGroupMasterId,
        }],
        list: {
            id: data.id,
            from: [authorName],
            title: data.title?.replace(/<[^>]+>/g, ""),
            color: avatarColor,
            shortContent: data?.content?.replace(/<[^>]*>|(&nbsp;)/g, " ").slice(0, 100),
            haveAttachment: data?.documentName ? true : false,
            msgRead: data?.msgRead == 1 ? true : false,
            haveForms: data?.portalAccountForm ? true : false,
            dateTime: lastmsgdatetime,
            dateTimelabel: dateTimeLog.listTimeLog,
        }


    };
}
/**
 * Mapping Outbox Messages
 *  @author Shaheel navas
 *  @return JSON
 */
export const OutboxMessageMapper = (data, currentDateTime, index) => {
    let authorName = wordCapitalize(data.authorName?.split(":")[0] ?? null),
        avatarColor = data.color ?? getRandomColor(),
        recipients = data?.recipients ? convertRecipientArray(data?.recipients) : [],
        recipientType = data?.recipients && recipients[0].type,
        lastmsgdatetime = data.modificationDate ?
            moment(data.modificationDate).locale('en').format(APP_LOCAL_DATE_TIME_FORMAT_TYPE2) : null,
        lastmsgdate = data.sentDate ?
            moment(data.sentDate).locale('en').format(APP_LOCAL_DATE_FORMAT_TYPE2) : null,
        lastmsgtime = data.sentDate ?
            moment(data.sentDate).locale('en').format(APP_LOCAL_TIME_FORMAT) : null,
        dateTimeLog = dateTimediff(currentDateTime, data.sentDate);
      
    return {
        id: data.id,
        //key: index,
        summary: data.title ?? null,
        lastmsgdatetime: lastmsgdatetime,
        lastmsgdate: lastmsgdate,
        lastmsgtime: lastmsgtime,
        author: authorName,
        authorId: data.authorId,
        portalMessageThreadId: data.portalMessagethreadId,
        avatar: null,
        content: data.content,
        color: avatarColor,
        msgStarred: data?.msgStarred == 1 ? true : false,/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */
        msgRead: true,
        recipientType: recipientType,
        group: data?.patientGroupMasterId !=0 ? true : false,
        patientGroupMasterId: data?.patientGroupMasterId, 
        thread: [{
            summary: data.title ?? '',
            messageId: data.id,
            portalMessageThreadId: data.portalMessagethreadId,
            author: authorName,
            authorId: data.authorId,
            avatar: data.avatar,
            content: data.content,
            color: avatarColor,
            datetime: data.sentDate ?
                moment(data.sentDate).locale('en').format(APP_LOCAL_DATE_TIME_FORMAT_TYPE2) : null,
            date: data.sentDate ?
                moment(data.sentDate).locale('en').format(APP_LOCAL_DATE_FORMAT_TYPE2) : null,
            time: data.sentDate ?
                moment(data.sentDate).locale('en').format(APP_LOCAL_TIME_FORMAT) : null,
            forms: data.portalAccountForm ? convertFormArray(data.portalAccountForm) : null,
            document: data?.documentName ? convertDocumentArray(data?.documentName) : null,
            fromLabel: authorName,
            toLabel: recipients.map(element => element.name),
            replyTo: recipients,
            msgRead: data?.msgRead == 1 ? true : false,
            recipientType: recipientType,
            recipients: data?.recipients,
            group: data?.patientGroupMasterId !=0 ? true : false,
            patientGroupMasterId: data?.patientGroupMasterId
        }],
        list: {
            id: data.id,
            from: recipients.map(element => element.name),
            title: data.title?.replace(/<[^>]+>/g, ""),
            color: avatarColor,
            shortContent: data?.content?.replace(/<[^>]*>|(&nbsp;)/g, " ").slice(0, 100),
            haveAttachment: data?.documentName ? true : false,
            msgRead: data?.msgRead == 1 ? true : false,
            haveForms: data?.portalAccountForm ? true : false,
            dateTime: lastmsgdatetime,
            dateTimelabel: dateTimeLog.listTimeLog

        }
    };
}
/**
 * Mapping Outbox Messages
 *  @author Shaheel navas
 *  @return JSON
 */
export const DraftMessageMapper = (data, currentDateTime, index) => {
    let authorName = wordCapitalize(data.authorName?.split(":")[0] ?? null),
        avatarColor = data.color ?? getRandomColor(),
        recipients = data?.recipients ? convertRecipientArray(data?.recipients) : [],
        recipientType = data?.recipients?.length <=0 ? 1 : recipients[0]?.type,
        lastmsgdatetime = data.modificationDate ?
            moment(data.modificationDate).locale('en').format(APP_LOCAL_DATE_TIME_FORMAT_TYPE2) : null,
        lastmsgdate = data.sentDate ?
            moment(data.sentDate).locale('en').format(APP_LOCAL_DATE_FORMAT_TYPE2) : null,
        lastmsgtime = data.sentDate ?
            moment(data.sentDate).locale('en').format(APP_LOCAL_TIME_FORMAT) : null,
        dateTimeLog = dateTimediff(currentDateTime, data.sentDate);

    return {
        id: data.id,
        //key: index,
        summary: data.title ?? null,
        lastmsgdatetime: lastmsgdatetime,
        lastmsgdate: lastmsgdate,
        lastmsgtime: lastmsgtime,
        author: authorName,
        authorId: data.authorId,
        portalMessageThreadId: data.portalMessagethreadId,
        avatar: null,
        content: data.content,
        color: avatarColor,
        msgStarred: data?.msgStarred == 1 ? true : false,/** Bug #1008 - @Author: Anupama P @Date 30Sep2022 */
        msgRead: true,
        recipientType: recipientType,
        thread: [{
            summary: data.title ?? '',
            messageId: data.id,
            portalMessageThreadId: data.portalMessagethreadId,
            author: authorName,
            authorId: data.authorId,
            avatar: data.avatar,
            content: data.content,
            color: avatarColor,
            datetime: data.sentDate ?
                moment(data.sentDate).locale('en').format(APP_LOCAL_DATE_TIME_FORMAT_TYPE2) : null,
            date: data.sentDate ?
                moment(data.sentDate).locale('en').format(APP_LOCAL_DATE_FORMAT_TYPE2) : null,
            time: data.sentDate ?
                moment(data.sentDate).locale('en').format(APP_LOCAL_TIME_FORMAT) : null,
            forms: data.portalAccountForm ? convertFormArray(data.portalAccountForm) : null,
            document: data?.documentName ? convertDocumentArray(data?.documentName) : null,
            fromLabel: authorName,
            toLabel: recipients.map(element => element.name),
            replyTo: recipients,
            recipientType: recipientType,
        }],
        list: {
            id: data.id,
            from: recipients.length <= 0 ? ['Draft'] : recipients.map(element => element.name),
            title: data.title ? data.title?.replace(/<[^>]+>/g, " ") : '(no subject)',
            color: avatarColor,
            shortContent: data?.content?.replace(/<[^>]*>|(&nbsp;)/g, " ").slice(0, 100),
            haveAttachment: data?.documentName ? true : false,
            haveForms: data?.portalAccountForm ? true : false,
            dateTime: lastmsgdatetime,
            dateTimelabel: dateTimeLog.listTimeLog
        }
    };
}
const messageInboxThread = (data) => {
    let threadData = [];
    _.map(data, (item, index) => {
        // console.log(data);
        // threadData.push({
        //     author: item.authorName,
        //     avatar: item.avatar,
        //     content: item.content,
        //     datetime: item.sentDate ?
        //         moment(item.sentDate).locale('en').format(APP_MESSAGE_TIME_FORMAT) : null,
        //     forms: convertFormArray(item.portalAccountForm)
        // });
    });
}
const convertFormArray = (formData) => {
    let formSplit = formData.split(", "),
        formArray = [];
    _.forEach(formSplit, (element) => {
        let elementsplit = element.split(":");
        formArray.push({
            id: parseInt(elementsplit[0]),
            formName: elementsplit[1],
            patientFormId: elementsplit[2] ?? null,
            locked: elementsplit[3]== 1 ? "true" : "false"
        })
    })
    return formArray;
}

const convertDocumentArray = (data) => {
    let documentSplit = data.split(", "),
        documentArray = [];
    _.forEach(documentSplit, (element) => {
        let elementsplit = element.split(":");
        documentArray.push({
            id: parseInt(elementsplit[0]),
            name: elementsplit[1] ?? "unknownFile",
        })
    })
    return documentArray;

}
const convertRecipientArray = (data) => {
    let recipientSplit
    if (data.startsWith(";")) {
        recipientSplit = data?.replace(";", " ").split(",")
    }
    else {
        recipientSplit = data?.replace(";", ", ").split(", ");
    }
    let recipients = [];
    _.forEach(recipientSplit, (element) => {
        let elementsplit = element.trim().split(":");
        recipients.push({
            id: parseInt(elementsplit[0]),
            name: elementsplit[1] ?? "",
            type: parseInt(elementsplit[2])
        })
    })
    return recipients;
}
const dateTimediff = (currentDateTime, msgDateTime) => {

    let currentTime = moment(currentDateTime),
        msgeTime = moment(msgDateTime),
        listTimeLog = '';
    let years = currentTime.diff(msgeTime, 'year');

    msgeTime.add(years, 'years');

    let months = currentTime.diff(msgeTime, 'months');
    msgeTime.add(months, 'months');

    let days = currentTime.diff(msgeTime, 'months');
    msgeTime.add(days, 'days');

    let hours = currentTime.diff(msgeTime, 'hours');
    msgeTime.add(hours, 'hours');

    let minutes = currentTime.diff(msgeTime, 'minutes');
    msgeTime.add(minutes, 'minutes');

    let seconds = currentTime.diff(msgeTime, 'seconds');

    if (years > 0) {
        listTimeLog = moment(msgDateTime).locale('en').format(APP_LOCAL_DATE_FORMAT_TYPE2);
    } else if (months > 0) {
        listTimeLog = moment(msgDateTime).locale('en').format(APP_MESSAGE_LIST_DAY_MONTH);
    } else if (years == 0 && months == 0 && days == 0) {
        listTimeLog = moment(msgDateTime).locale('en').format(APP_LOCAL_TIME_FORMAT);
    } else {
        listTimeLog = moment(msgDateTime).locale('en').format(APP_LOCAL_DATE_TIME_FORMAT_TYPE2);
    }

    return { listTimeLog };


}
